import { AxiosInstance } from 'axios';
import { result, Result } from 'util/result';
import { GitConfigResponse } from 'data/terra/api/terra/response/GitConfigResponse';
import { GetBuildFlavorsResponse } from 'data/terra/api/terra/response/GetBuildFlavorsResponse';
import { UpsertGitConfigRequest } from 'data/terra/api/terra/request/UpsertGitConfigRequest';

class GitConfigEndpoint {
  gitConfigByAppIdUrl = (appId: string) => `api/v1/git-config/app/${appId}`;
  getBuildFlavorsInGitConfig = (gitConfigId: string) => `api/v1/git-config/${gitConfigId}/build-flavors`;
}

export class GitConfigApi {
  terraClient: AxiosInstance;
  endpoint = new GitConfigEndpoint();

  constructor(client: AxiosInstance) {
    this.terraClient = client;
  }

  getGitConfigByAppId(appId: string): Promise<Result<GitConfigResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<GitConfigResponse>(
            this.endpoint.gitConfigByAppIdUrl(appId),
          )
        ).data
    );
  }

  upsertGitConfigByAppId(appId: string, request: UpsertGitConfigRequest): Promise<Result<GitConfigResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.put<GitConfigResponse>(
            this.endpoint.gitConfigByAppIdUrl(appId),
            request
          )
        ).data
    );
  }

  getBuildFlavorsInGitConfig(gitConfigId: string): Promise<Result<GetBuildFlavorsResponse>> {
    return result(
      async () =>
        (
          await this.terraClient.get<GetBuildFlavorsResponse>(
            this.endpoint.getBuildFlavorsInGitConfig(gitConfigId),
          )
        ).data
    );
  }
}
